<div class="page-wrap">
  <div class="pinned">
    <div class="title">
      <nb-route-tabset [tabs]="tabs" [fullWidth]="true" [activeLinkOptions]="{exact: false}"></nb-route-tabset>
    </div>
    <div class="buttons">
<!--      @if (count) {-->
<!--        <label class="count">{{ 'results' | plural:count | translate:{value: count.toLocaleString()} }}</label>-->
<!--      }-->
      <bst-table-options-button [count]="filterCount" (open)="events.next(DualAxisEvent.OPENFILTERS)"></bst-table-options-button>
    </div>
  </div>

  <bst-dual-axis [tag]="'time_approvals'" [delegate]="this" [bootstrap]="true" [pagingMode]="Globals.PagesMode"></bst-dual-axis>
</div>

<ng-template #cellTemplate let-request="row" let-column="column" let-node="node">
  @switch (column.name) {
    @case ('employee') {
      <nb-user color="#eee" size="medium" [picture]="Globals.logo(request.employee)" [name]="employeeName(request) || ('approvals.unknown_employee' | translate)"></nb-user>
    }
    @case ('week') { <span>{{ request.week_start | localedate:'D MMM YYYY' }}</span> }
    @case ('hours') { <span class="num">{{ duration(totalSeconds(request)) }}</span> }
    @case ('billable') { <span class="num">{{ duration(billableSeconds(request)) }}</span> }
    @case ('projects') { <span class="projects">{{ projectNames(request) }}</span> }
    @case ('status') {
      <span class="status-chip"
            [class.submitted]="request.status === TrackedStatus.Submitted"
            [class.approved]="request.status === TrackedStatus.Approved"
            [class.rejected]="request.status === TrackedStatus.Rejected">{{ statusLabel(request.status) }}</span>
    }
    @case ('submitted') { <span>{{ request.submitted_at ? (request.submitted_at | localedate:'D MMM YYYY') : '' }}</span> }
  }
</ng-template>

<!-- Mobile/card layout — bst-dual-axis renders this per row below its breakpoint and
     wires the card's click to selectRow(), so the same drill-down dialog opens. -->
<ng-template #cardTemplate let-request="row" let-node="node">
  <div class="a-card">
    <div class="a-card-head">
      <nb-user color="#eee" size="medium" [picture]="Globals.logo(request.employee)" [name]="employeeName(request) || ('approvals.unknown_employee' | translate)"></nb-user>
      <span class="status-chip"
            [class.submitted]="request.status === TrackedStatus.Submitted"
            [class.approved]="request.status === TrackedStatus.Approved"
            [class.rejected]="request.status === TrackedStatus.Rejected">{{ statusLabel(request.status) }}</span>
    </div>
    <div class="a-card-meta">
      <span class="week">{{ request.week_start | localedate:'D MMM YYYY' }}</span>
      <span class="hours num">{{ duration(totalSeconds(request)) }}</span>
    </div>
    @if (projectNames(request); as projects) {
      <div class="a-card-projects">{{ projects }}</div>
    }
  </div>
</ng-template>
